import { useCallback } from 'react'
import { baseHttpRequest } from 'views/CustomerFacingDisplay/utils/cfdHttpRequest'
import cfdToast from 'views/CustomerFacingDisplay/utils/cfdToast'

interface IConfig {
    showErrorToast?: boolean
    showSuccessToast?: boolean
    errorMessage?: string
    successMessage?: string
}

const useCustomFetch = () => {
    const fetchWithCustomUrl = useCallback(
        async <T>(url: string, config: IConfig = {}) => {
            const {
                showErrorToast = true,
                showSuccessToast = true,
                errorMessage = 'Loading Fail',
                successMessage = 'Load successful',
            } = config
            const request = baseHttpRequest()
            let uri = url
            // if the url not start with http:// or https://
            // the url will start with baseUrl of client
            if (!/^http[sS]{0,1}:\/\/.*/.test(url)) {
                uri = `https://${url}`
            }

            try {
                const res = await request.get<T>(uri)
                if (showSuccessToast) cfdToast.success(successMessage)
                return res
            } catch (error) {
                if (showErrorToast) cfdToast.error(errorMessage)
            }
        },
        [],
    )

    return fetchWithCustomUrl
}

export default useCustomFetch
